export const sanitizeGTMString = (value: string | null | undefined): string => {
  if (!value) return '';

  return value
    .replace(/\\["'nrt]|\\/g, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&[^;]+;/g, '')
    .replace(/["'`\\<>]|[\x00-\x1F\x7F]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};
